module.exports = __webpack_public_path__ + "static/media/apple-logo.44715165.svg";